const isManualRefunds = (p) => p.service_name === "manual_refunds"

const shouldKeepForAdminIntegrationsView = (ctx) => (p) => {
  if (ctx.isAdmin && !ctx.usersViewForAdmin) return !!p.is_connected
  return true
}

const mapProcessor = (ctx) => (p) => ({
  ...p,
  is_connected: p.is_connected,
  title: p.title || ctx.paymentProcessorTitle?.[p.service_name] || p.service_name,
  simpleDisabled:
    (ctx.usersViewForAdmin && !p.is_connected) || (ctx?.businessAccount?.is_demo && !ctx.isAdmin)
})

const getTrailingItem = (ctx) => {
  return ctx.isAdmin || ctx.userInfo?.is_demo ? {} : ctx.dataRequestIntegration
}

export function buildProcessors(paymentProcessors, ctx) {
  const list = (paymentProcessors ?? [])
    .filter(shouldKeepForAdminIntegrationsView(ctx))
    // TODO: if we need hide manual_refunds
    // .filter((p) => !isManualRefunds(p))
    .map(mapProcessor(ctx))

  return [...list, getTrailingItem(ctx)]
}
